module.exports = __webpack_public_path__ + "static/media/sustainable.1d20fb6c.svg";